import { createSlice, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { BannerType, BannerWhere, DataRow, DropDownOptions, } from "../interfaces";
import {generateDeepLink, updateDeepLink} from "../helpers/deep-link-provider";
import {IIndexable} from "../../../../domain/interfaces";

export interface StateInterface extends IIndexable{
    AllRows:DataRow[];
    BannerRows: DataRow[];
    BannerTypes: BannerType[];
    BannerWheres: BannerWhere[];
    ConditionRows: DataRow[];
    FilteredBannerRows: DataRow[];
    ActiveInactiveFilterValue: string;
    BannerTypeFilterValue: any ;
    BannerNameFilterValue: any;
    BannerPartialNameFilterValue:string;
    DropDownOptions: DropDownOptions;
    IsBannerAssignedFilterValue:boolean;
    PageType: string;
    EditCreateItemId:string;
    //for create/edit page&condition -> onload set related banner
    BannerId:string;
    //Search by page url -> bannerIds of the last URL search.
    SearchByUrlBannerIDS:number[],
    SearchByUrlCurrentPageUrl:string
}

// initial state
const initialState: StateInterface = {
    AllRows:[],
    BannerRows: [],
    BannerTypes:[],
    BannerWheres: [],
    ConditionRows: [],
    FilteredBannerRows: [],
    ActiveInactiveFilterValue:"Show All",
    BannerTypeFilterValue: { label: "filter by type", value: "Show All Types"},
    BannerNameFilterValue: { label: "filter by name", value: "Show All"},
    BannerPartialNameFilterValue: "",
    DropDownOptions: {bannerTypes :[] , bannerNames :[] } as DropDownOptions,
    IsBannerAssignedFilterValue:false,
    PageType: "",
    EditCreateItemId:"",
    BannerId:"",
    SearchByUrlBannerIDS:[],
    SearchByUrlCurrentPageUrl:""
};
//[] as BannerRow[];
// the main slice
const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
        refreshDeepLink(state, action) {

            const updatedState =  {
                ...state,
                ...action.payload,
            };

            const deepLink = generateDeepLink(
                updatedState.PageType,
                updatedState.EditCreateItemId,
                updatedState.BannerId
            );

            updateDeepLink(deepLink);

            return updatedState;
        },
    },
});

const store = configureStore({
    reducer: rootSlice.reducer,
});

export const rootActions = rootSlice.actions;
export default store;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
